"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Acreage {
    // eslint-disable-next-line no-useless-constructor
    constructor(value, unit, precise) {
        this.precise = precise || false;
        this.unit = unit || '';
        this.value = this.polishValue(value);
        this.label = '';
        this.shortLabel = '';
        this.buildLabels();
    }
    setValue(newVal) {
        this.value = newVal;
        this.buildLabels();
    }
    polishValue(v) {
        if (!this.precise) {
            if (v < 1 && v !== 0)
                return 1;
            return Math.round(v * 100) / 100;
        }
        else {
            return Math.round(v * 100) / 100;
            ;
        }
    }
    shortenUnit(u) {
        if (u.toLowerCase().charAt(0) === 'h')
            return 'ha';
        if (u.toLowerCase().charAt(0) === 'a')
            return 'ac';
        return u.toLowerCase().charAt(0);
    }
    buildLabels() {
        if (this.precise) {
            if (this.value === -1) {
                this.label = '---';
                this.shortLabel = '---';
            }
            else {
                this.label = this.value + ' ' + this.unit;
                this.shortLabel = this.value + ' ' + this.shortenUnit(this.unit);
            }
        }
        else {
            if (this.value >= 0) {
                if (this.value === 0) {
                    this.label = '0 ' + this.unit;
                    this.shortLabel = '0 ' + this.shortenUnit(this.unit);
                }
                else if (this.value > 0) {
                    this.label = this.value + ' ' + this.unit;
                    this.shortLabel = this.value + ' ' + this.shortenUnit(this.unit);
                }
                else {
                    this.label = '< 1' + this.unit;
                    this.shortLabel = '< 1' + this.shortenUnit(this.unit);
                }
            }
            else {
                this.label = 'No Acreage';
                this.shortLabel = 0 + ' ' + this.shortenUnit(this.unit);
            }
        }
    }
    switchToHectareas() {
        if (this.shortenUnit(this.unit) === 'ha')
            return;
        if (this.shortenUnit(this.unit) === 'ac') {
            this.value = this.polishValue(this.value / 2.47105);
            this.unit = 'hectareas';
        }
        this.buildLabels();
    }
    switchToAcres() {
        if (this.shortenUnit(this.unit) === 'ac')
            return;
        if (this.shortenUnit(this.unit) === 'ha') {
            this.value = this.polishValue(this.value * 2.47105);
            this.unit = 'acres';
        }
        this.buildLabels();
    }
    toggleUnits() {
        if (this.shortenUnit(this.unit).startsWith('a')) {
            this.switchToHectareas();
        }
        else if (this.shortenUnit(this.unit).startsWith('h')) {
            this.switchToAcres();
        }
    }
    get shortUnit() {
        return this.shortenUnit(this.unit);
    }
}
exports.default = Acreage;
